module.exports = __webpack_public_path__ + "img/mexico.9c43c4d0.png";